import {
  NodeViewContent,
  NodeViewProps,
  NodeViewWrapper,
} from "@tiptap/react";
import { IconPlus } from "@tabler/icons-react";

function genId(): string {
  try {
    if (
      typeof crypto !== "undefined" &&
      typeof (crypto as any).randomUUID === "function"
    ) {
      return (crypto as any).randomUUID().replace(/-/g, "").slice(0, 8);
    }
  } catch {
    // noop
  }
  return Math.random().toString(36).slice(2, 10);
}

export default function StepperView(props: NodeViewProps) {
  const { node, editor, getPos } = props;

  const addStep = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof getPos !== "function") return;
    const pos = getPos();
    if (pos == null) return;
    const end = pos + node.nodeSize - 1;
    editor
      .chain()
      .focus()
      .insertContentAt(end, {
        type: "step",
        attrs: { id: genId() },
        content: [
          { type: "stepTitle" },
          { type: "stepContent", content: [{ type: "paragraph" }] },
        ],
      })
      .run();
  };

  return (
    <NodeViewWrapper data-type="stepper" className="stepper-wrapper">
      <NodeViewContent as="div" className="stepper" />
      <button
        type="button"
        className="stepper-add"
        onMouseDown={(e) => e.preventDefault()}
        onClick={addStep}
        contentEditable={false}
      >
        <IconPlus size={14} />
        <span>Add step</span>
      </button>
    </NodeViewWrapper>
  );
}
